(function () {
  function HPExtendProductMEdia() {
    const shapesInputs = document.querySelectorAll('[name*="-shapes"]');
    const params = new URLSearchParams(document.location.search);
    const shape = params.get('shape'); // is the string "Jonathan"
    if (shape) {
      const shapeInput = document.querySelector(`[name*="-shapes"][value="${shape}"]`);
      if (shapeInput) {
        shapeInput.checked = true;
        // dispatch change event
        const event = new Event('change');
        shapeInput.dispatchEvent(event);
      }
    }
    shapesInputs.forEach((shape) => {
      shape.addEventListener('change', (e) => {
        setTimeout(() => {
          this.updateMedia();
          this.updateUrl();
        }, 100);
      });
    });
    document.body.addEventListener('variantChange', (e) => {
      console.log('variantChange', e);
      const variant = e.detail;
      this.updateMedia(variant);
      this.updateUrl(variant);
    });

    this.getMedia = async function (handle, shape, variant) {
      let sections_url = window.hp_extend_product_media.product_url;
      const variant_id = variant?.id || document.querySelector('[name=id]')?.value;
      if (variant_id && sections_url) {
        sections_url = sections_url + '?variant=' + variant_id;
      }
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        body: JSON.stringify({
          attributes: { media_group_handle: handle, tempShape: shape, var_id: +variant_id },
          sections: 'get-ring-media',
          sections_url: sections_url || window.location.href,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const json = await response.json();
      const mediaHtml = json.sections['get-ring-media'];
      return mediaHtml;
    };

    this.updateMedia = async (variant) => {
      if (!document.querySelector('[name*="-shapes"]')) return;
      const variant_id = variant?.id || document.querySelector('[name=id]')?.value;
      const oldMedia = document.querySelector('.product-medias[data-media-group-handle]');
      const selectedShape = document.querySelector('[name*="-shapes"]:checked').value;
      const selectedMetal = document.querySelector('[data-option-name="metal"] input:checked').value;
      let media_group_handle = `${window.hp_extend_product_media.product_title}-${selectedMetal.toLowerCase().replace('k ', '-k ')}-${selectedShape}`;

      media_group_handle = media_group_handle
        .replace(/\//g, '') // Remove all slashes
        .replace(/\s+/g, '-') // Replace all sequences of spaces with a single dash
        .toLowerCase(); // Convert to lowercase
      // remove all '/' from the handle

      if (
        document.querySelector(`.product-medias[data-media-group-handle="${media_group_handle}"]`) ||
        document.querySelector(`.product-medias[data-media-group-handle="${media_group_handle}-variant-${variant_id}"]`)
      ) {
        console.log('media already loaded');
        return;
      }
      oldMedia.style.opacity = 0.2;
      const txt = await this.getMedia(media_group_handle, selectedShape, variant);
      const section = new DOMParser().parseFromString(txt, 'text/html');
      try {
        //if (!section.querySelector('[data-has-metafields-media]')) return;
        oldMedia.replaceWith(section.querySelector('.product-medias[data-media-group-handle]'));
      } catch (error) {
        console.error('error', error);
      } finally {
        oldMedia.style.opacity = 1;
      }
      document.body.dispatchEvent(new CustomEvent('mediaUpdated', { detail: section }));
    };

    this.updateUrl = () => {
      const selectedShape = document.querySelector('[name*="-shapes"]:checked');
      if (!selectedShape) return;

      var params = [];
      window.location.search.length > 1 &&
        (params = window.location.search
          .slice(1)
          .split('&')
          .filter(function (e) {
            return 0 !== e.indexOf('shape=');
          })),
        params.push('shape=' + selectedShape.value);
      const newState = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + params.join('&');
      window.history.replaceState({ path: newState }, '', newState);
    };
  }
  new HPExtendProductMEdia();
})();
